<template>
  <vs-row vs-type="flex" vs-w="12" style="height: 90%">
    <vs-popup
      :active.sync="isOpenExtraVariantSelectPage"
      title="Ekstra Varyant Seçimi"
      id="extra-variant-selection"
    >
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12" class="bg-primary">
          <vs-col
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            class="mx-5 py-4"
          >
            <p class="text-white bold h4">Ekstra Varyant Seçimi</p>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          vs-justify="center"
          class="p-5"
          id="variantsContent"
        >
          <vs-col
            v-for="extra in extraVariants"
            :key="extra.id"
            :vs-w="!isMobile ? 4 : 6"
            class="pt-5 px-3"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                <div
                  class="bg-secondary half-friendly-border sale-box-shadow w-full py-3 align-center"
                  @click="extra.quantity++"
                >
                  <p class="extra-name bold px-3">{{ extra.name }}</p>
                </div>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-5">
                <vs-button
                  class="quantity-button bg-white text-primary"
                  size="large"
                  radius
                  color="transparent"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-minus"
                  @click="extra.quantity > 0 ? extra.quantity-- : null"
                >
                </vs-button>
                <p class="extra-name bold mx-5 mt-2">{{ extra.quantity }}</p>
                <vs-button
                  class="quantity-button bg-white text-primary"
                  size="large"
                  radius
                  color="transparent"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="extra.quantity++"
                ></vs-button>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          vs-justify="center"
          class="my-3"
          style="height: 3.5rem !important"
          v-if="currentTab !== 'menu'"
        >
          <vs-col vs-type="flex" class="w-1/2">
            <vs-button
              class="action-button sale-box-shadow mr-5"
              type="gradient"
              @click="cancelExtraVariantSelection"
              color="danger"
              icon-pack="feather"
              icon="icon-arrow-left"
            >
              VAZGEÇ
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" class="w-1/2">
            <vs-button
              class="action-button sale-box-shadow sale-text-shadow ml-5"
              @click="saveExtraVariantSelection"
              color="success"
              icon-pack="feather"
              icon="icon-arrow-right"
              icon-after
            >
              ONAYLA
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>

    <vs-row vs-type="block" vs-w="12" vs-justify="flex-start" class="">
      <vs-col
        style="height: fit-content"
        v-for="extra in selectedExtras"
        :key="extra.id"
        :vs-w="!isMobile ? 6 : 12"
        class="pt-5 px-2"
      >
        <vs-row vs-type="flex" vs-w="12">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            style="z-index: 5"
          >
            <div
              class="bg-secondary half-friendly-border sale-box-shadow w-full py-3 align-center"
              @click="
                extra.variants != null && extra.variants.length > 0
                  ? openExtraVariantSelectPage(extra)
                  : extra.quantity++
              "
            >
              <p class="extra-name bold px-3">{{ extra.name }}</p>
            </div>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="20"
            vs-justify="center"
            class="my-5"
            style="height: 44px !important"
            v-if="
              (extra.variants == null || extra.variants.length == 0) &&
              currentTab !== 'menu'
            "
          >
            <vs-button
              class="quantity-button bg-white text-primary"
              size="large"
              radius
              color="transparent"
              type="gradient"
              icon-pack="feather"
              icon="icon-minus"
              @click="extra.quantity > 0 ? extra.quantity-- : null"
            >
            </vs-button>
            <p class="extra-name extra-quantity bold mt-2">
              {{ extra.quantity }}
            </p>
            <vs-button
              class="quantity-button bg-white text-primary"
              size="large"
              radius
              color="transparent"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              @click="extra.quantity++"
            ></vs-button>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="12"
            v-else
            class="mt-5"
            vs-justify="left"
            id="selectedExtraVariants"
          >
            <vs-row
              v-show="variant.quantity > 0"
              vs-type="flex"
              vs-w="10"
              vs-align="left"
              vs-justify="left"
              v-for="variant in extra.variants"
              :key="variant.id"
            >
              <p class="text-left">
                -{{ variant.name }} x {{ variant.quantity }}
              </p>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row
      vs-type="flex"
      vs-w="12"
      vs-justify="center"
      class="mt-auto mb-6"
      style="height: 3.5rem !important"
      v-if="currentTab !== 'menu'"
    >
      <vs-col vs-type="flex" vs-justify="center" class="w-1/2">
        <vs-button
          class="action-button sale-box-shadow mr-5"
          type="gradient"
          @click="cancelExtras"
          color="danger"
          icon-pack="feather"
          icon="icon-arrow-left"
        >
          VAZGEÇ
        </vs-button>
      </vs-col>
      <vs-col vs-type="flex" class="w-1/2" vs-justify="center">
        <vs-button
          class="action-button sale-box-shadow sale-text-shadow ml-5"
          @click="saveExtras"
          color="success"
          icon-pack="feather"
          icon="icon-arrow-right"
          icon-after
        >
          ONAYLA
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      isSaveVariants: false,
      selectedExtrasDefault: null,
      isOpenExtraVariantSelectPage: false,
      extraVariants: [],
      selectedExtras: [],
      isMobile: null,
    };
  },

  props: {
    currentTab: {
      type: String,
      require: true,
    },
    extras: {
      type: Array,
      required: true,
    },
  },
  watch: {
    isOpenExtraVariantSelectPage(val) {
      if (val) {
        this.selectedExtrasDefault = _.cloneDeep(this.selectedExtras);
        this.isSaveVariants = false;
      } else if (!val && !this.isSaveVariants) {
        this.selectedExtras = this.selectedExtrasDefault;
      }
    },
  },
  created: function () {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
    this.selectedExtras = [];
    this.extras.forEach((item) => {
      this.selectedExtras.push({
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity ? item.quantity : 0,
        variants:
          item.variants != null && item.variants.length > 0
            ? this.fillExtraVariants(item.variants)
            : null,
      });
      this.selectedExtrasDefault = _.cloneDeep(this.selectedExtras);
    });
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    saveExtraVariantSelection() {
      this.isSaveVariants = true;
      this.isOpenExtraVariantSelectPage = false;
    },
    cancelExtraVariantSelection() {
      this.selectedExtras = this.selectedExtrasDefault;
      this.isOpenExtraVariantSelectPage = false;
    },
    fillExtraVariants(variants) {
      let variantModel = [];
      variants.forEach((variant) => {
        variantModel.push({
          id: variant.id,
          name: variant.name,
          price: variant.price,
          quantity: variant.quantity ? variant.quantity : 0,
        });
      });
      return variantModel;
    },
    closeVariantSelection() {},
    openExtraVariantSelectPage(extra) {
      this.isOpenExtraVariantSelectPage = true;
      this.extraVariants = extra.variants;
    },
    saveExtras: function () {
      let extraObj = [];
      this.selectedExtras.forEach((item) => {
        let extra = {
          id: item.id,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
          variants: [],
        };
        if (item.variants != null && item.variants.length > 0) {
          item.variants.forEach((variant) => {
            extra.variants.push({
              id: variant.id,
              name: variant.name,
              price: variant.price,
              quantity: variant.quantity,
            });
          });
        }
        extraObj.push(extra);
      });
      this.$emit("saveExtras", extraObj);
    },
    cancelExtras: function () {
      this.$emit("cancelExtras");
    },
  },
  destroyed: function () {
    window.removeEventListener("resize", this.checkScreen);
  },
};
</script>

<style>
.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  font-weight: 600 !important;
  border-radius: 1rem !important;
  text-shadow: 1px 1px 1px rgb(63, 63, 63) !important;
}

@media screen and (min-width: 768px) {
  .action-button {
    font-size: 1.2vw !important;
  }
}

.extra-name {
  font-size: 1rem;
  color: #9a2411;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600 !important;
}

#extra-variant-selection .vs-popup .vs-popup--content {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

#extra-variant-selection .vs-popup {
  border-top-left-radius: 2rem !important;
  width: 800px !important;
  border-top-right-radius: 2rem !important;
}

#extra-variant-selection .vs-popup .vs-popup--content .vs-row .vs-col button i {
  font-weight: 600 !important;
}

#extra-variant-selection .vs-popup .vs-popup--header {
  display: none !important;
}

#selectedExtraVariants {
  height: 80px;
  font-weight: 600;
  overflow-x: scroll;
  overflow-y: scroll;
  white-space: nowrap;
  font-size: 0.75rem;
}
#selectedExtraVariants::-webkit-scrollbar-corner {
  background: transparent !important;
}

#variantsContent {
  max-height: 440px;
  overflow-y: auto;
}

#variantsContent::-webkit-scrollbar {
  height: 0;
}

.extra-quantity {
  width: 44px;
  margin: 0 !important;
  line-height: 44px;
  text-align: center;
}
</style>
